// Country chip configuration - centralized styling for AU/NZ/US country chips
// Used across admin FP list, FP directory, exception tables, system connections

/**
 * Two-letter market/country prefix from an fp_code ('auuns' -> 'AU').
 * Canonical home for the prefix-slice so callers don't re-roll it.
 */
export const deriveCountryCode = (fpCode: string | undefined | null): string =>
  fpCode && typeof fpCode === 'string' ? fpCode.slice(0, 2).toUpperCase() : ''

export interface CountryChipConfig {
  emoji: string
  backgroundColor: string
  borderColor: string | undefined
}

/**
 * Get country chip styling configuration
 * Colors match the admin FP list styling exactly:
 * - AU: Blue (#E3F2FD bg, #90CAF9 border)
 * - NZ: Purple (#F3E5F5 bg, #E1BEE7 border)
 * - US: Red (#FFEBEE bg, #FFCDD2 border)
 */
export const getCountryChipConfig = (country: string): CountryChipConfig => ({
  emoji: country === 'AU' ? '🇦🇺' : country === 'NZ' ? '🇳🇿' : country === 'US' ? '🇺🇸' : '--',
  backgroundColor: country === 'AU' ? '#E3F2FD' :
                  country === 'NZ' ? '#F3E5F5' :
                  country === 'US' ? '#FFEBEE' : 'transparent',
  borderColor: country === 'AU' ? '#90CAF9' :
              country === 'NZ' ? '#E1BEE7' :
              country === 'US' ? '#FFCDD2' : undefined
})

/**
 * Get chip sx props for a country chip
 * Returns MUI sx object ready to spread into Chip component
 */
export const getCountryChipSx = (country: string) => {
  const config = getCountryChipConfig(country)
  return {
    backgroundColor: config.backgroundColor,
    borderColor: config.borderColor,
    '& .MuiChip-label': {
      fontWeight: 500
    }
  }
}
